<app-main-layout>
  <section class="flex flex-col gap-3">
    <app-card>
      <app-card-header
        title="Nutzerprofil"
        [iconPath]="'assets/icons/identification-card.svg'"
      />

      <div class="flex flex-col justify-start items-start">
        <button
          class="flex items-center justify-start gap-2 w-full p-3 border-b border-t text-dark-grey"
          (click)="openModal(ModalChangeUserComponent)"
        >
          <app-icon
            color="var(--dark-grey)"
            path="/assets/icons/identification-card-light.svg"
            [width]="28"
            [height]="28"
          />

          <span>Profil bearbeiten</span>
        </button>

        <button
          class="flex items-center justify-start gap-2 w-full p-3 border-b text-dark-grey"
          (click)="openModal(ModalChangePasswordComponent)"
        >
          <app-icon
            color="var(--dark-grey)"
            path="/assets/icons/key-light.svg"
            [width]="28"
            [height]="28"
          />
          <span>Passwort ändern</span>
        </button>

        <button
          class="flex items-center justify-start gap-2 w-full p-3 border-b text-red-500"
          (click)="openModal(ModalDeleteUserComponent)"
        >
          <app-icon
            color="var(--alert)"
            path="/assets/icons/trash-light.svg"
            [width]="28"
            [height]="28"
          />

          <span>Profil löschen</span>
        </button>
      </div>

      @if (isCoach()) {
        <div class="mt-8">
          <button
            class="flex items-center justify-between gap-2 w-full p-3 border-t text-dark-grey"
            (click)="openModal(ModalLeaderBoardComponent)"
          >
            <div class="flex gap-2 items-center">
              <app-icon
                color="var(--dark-grey)"
                path="/assets/icons/chart-bar-light.svg"
                [width]="28"
                [height]="28"
              />

              <span>Check-In Übersicht</span>
            </div>
          </button>

          <button
            class="flex items-center justify-between gap-2 w-full p-3 border-t border-b text-dark-grey"
            (click)="openModal(ModalCheckInExportComponent)"
          >
            <div class="flex gap-2 items-center">
              <app-icon
                color="var(--dark-grey)"
                path="/assets/icons/download-simple-light.svg"
                [width]="28"
                [height]="28"
              />

              <span>Datenexport</span>
            </div>
          </button>
        </div>
      }

      <button
        class="flex items-center justify-between gap-2 w-full p-3 border-t border-b text-dark-grey mt-8"
        (click)="goToPrivacyPolicy()"
      >
        <div class="flex gap-2 items-center">
          <app-icon
            color="var(--dark-grey)"
            path="/assets/icons/fingerprint-light.svg"
            [width]="28"
            [height]="28"
          />

          <span>Datenschutz</span>
        </div>

        <app-icon
          color="var(--dark-grey)"
          [width]="20"
          [height]="20"
          path="/assets/icons/caret-right-bold.svg"
        >
        </app-icon>
      </button>

      <button
        class="flex items-center justify-between gap-2 w-full p-3 border-t border-b text-dark-grey mt-8"
        (click)="logout()"
      >
        <div class="flex gap-2 items-center">
          <app-icon
            color="var(--dark-grey)"
            path="/assets/icons/sign-out-light.svg"
            [width]="28"
            [height]="28"
          />

          <span>Abmelden</span>
        </div>
      </button>
    </app-card>
  </section>
</app-main-layout>
